'use strict';

var schema = Object.assign({}, require('./chain_types.json'));

module.exports = schema;


//////////////////
// WEBPACK FOOTER
// ./node_modules/eosjs/lib/schema/index.js
// module id = mUHv
// module chunks = 0